<template>
  <div class="agent-stats-page">
    <!-- 搜索表单 -->
    <div class="common-seach-wrap">
      <el-form size="small" inline :model="searchForm" class="demo-form-inline">
        <!-- 用户选择 -->
        <el-form-item label="选择用户">
          <el-row :gutter="10">
            <el-col :span="18">
              <el-input
                v-model="selectedUserName"
                placeholder="请选择用户"
                readonly
                style="width: 300px"
              >
                <template slot="append">
                  <el-button @click="openUserDialog" icon="el-icon-search">选择用户</el-button>
                </template>
              </el-input>
            </el-col>
            <el-col :span="6" v-if="selectedUser">
              <el-button @click="clearUserSelection" type="text" icon="el-icon-close">清除</el-button>
            </el-col>
          </el-row>
        </el-form-item>    
        <!-- 日期范围 -->
        <el-form-item label="日期范围">
          <el-date-picker
            v-model="searchForm.dateRange"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
        </el-form-item>
        
        <!-- 快捷筛选 -->
        <el-form-item label="快捷筛选">
          <el-radio-group v-model="activeQuickFilter" @change="changeQuickFilter">
            <el-radio-button v-for="(item, index) in quickFilters" :key="index" :label="index">
              {{ item.name }}
            </el-radio-button>
          </el-radio-group>
        </el-form-item>
        
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
          <el-button @click="resetSearch">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 用户信息卡片 -->
    <el-card v-if="selectedUser" class="user-info-card" shadow="never">
      <div slot="header" class="clearfix">
        <span>用户信息</span>
        <el-button style="float: right; padding: 3px 0" type="text" @click="clearUserSelection">
          清除选择
        </el-button>
      </div>
      <el-row :gutter="20">
        <el-col :span="6">
          <div class="user-info-item">
            <img :src="selectedUser.avatarUrl" class="user-avatar" width="40" height="40" />
          </div>
        </el-col>
        <el-col :span="6">
          <div class="user-info-item">
            <label>用户ID：</label>
            <span>{{ selectedUser.user_id }}</span>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="user-info-item">
            <label>昵称：</label>
            <span>{{ selectedUser.nickName }}</span>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="user-info-item">
            <label>手机号：</label>
            <span>{{ selectedUser.mobile || '未填写' }}</span>
          </div>
        </el-col>
        <el-col :span="6" v-if="selectedUser.role">
          <div class="user-info-item">
            <label>角色：</label>
            <el-tag :type="getRoleType(selectedUser.role)" size="small">
              {{ getRoleText(selectedUser.role) }}
            </el-tag>
          </div>
        </el-col>
      </el-row>
    </el-card>

    <!-- 数据统计 -->
    <el-card class="stats-card" shadow="never" v-if="selectedUser">
      <el-row :gutter="20">
        <!-- 个人数据 -->
        <el-col :span="3">
          <div class="stat-item">
            <div class="stat-value">{{ displayUser.saletask || 0 }}</div>
            <div class="stat-label">年度销售任务</div>
          </div>
        </el-col>
        <el-col :span="3">
          <div class="stat-item">
            <div class="stat-value">{{ displayUser.company_num || 0 }}</div>
            <div class="stat-label">已完成</div>
          </div>
        </el-col>
        <el-col v-if="selectedUser" :span="3">
          <div class="stat-item">
            <div class="stat-value" style="color: #ff7600;">{{ (displayUser.jsj / 10) || 0 }}折</div>
            <div class="stat-label">结算价</div>
          </div>
        </el-col>
        <el-col :span="3">
          <div class="stat-item">
            <div class="stat-value">{{ displayUser.direct_completed || 0 }}家</div>
            <div class="stat-label">直营完成</div>
          </div>
        </el-col>
        <el-col :span="3">
          <div class="stat-item">
            <div class="stat-value">{{ displayUser.channel_completed || 0 }}家</div>
            <div class="stat-label">渠道完成</div>
          </div>
        </el-col>
        <el-col :span="3">
          <div class="stat-item">
            <div class="stat-value">{{ displayUser.city_completed || 0 }}家</div>
            <div class="stat-label">市级完成</div>
          </div>
        </el-col>
        <el-col :span="3">
          <div class="stat-item">
            <div class="stat-value">{{ displayUser.total_completed || displayUser.company_num || 0 }}家</div>
            <div class="stat-label">总计完成</div>
          </div>
        </el-col>
        
        <!-- 团队数据 - 仅省经销商显示 -->
        <template v-if="selectedUser && (selectedUser.role === 'province' || selectedUser.role === 'company_province')">
          <el-col :span="5">
            <div class="stat-item team-stat" @click="viewTeamRecords('personal')">
              <div class="stat-value">{{ formatAmount(displayUser.current_user_total || 0) }}元</div>
              <div class="stat-label">直营客户奖励</div>
              <div class="stat-trend" v-if="teamIncomeTrend > 0">
                <i class="el-icon-top" style="color: #f56c6c;"></i>
                {{ formatAmount(displayUser.current_user_total || 0) }}元
              </div>
              <div class="stat-trend" v-else-if="teamIncomeTrend < 0">
                <i class="el-icon-bottom" style="color: #67c23a;"></i>
                {{ formatAmount(displayUser.current_user_total || 0) }}元
              </div>
              <div class="stat-hover">点击查看详情</div>
            </div>
          </el-col>
          <el-col :span="5">
            <div class="stat-item team-stat" @click="viewTeamRecords('channel')">
              <div class="stat-value">{{ formatAmount(teamTotalProfit) }}</div>
              <div class="stat-label">渠道推荐奖励</div>
              <div class="stat-trend" v-if="teamProfitTrend > 0">
                <i class="el-icon-top" style="color: #f56c6c;"></i>
                {{ formatAmount(displayUser.channel_users_total || 0) }}元
              </div>
              <div class="stat-trend" v-else-if="teamProfitTrend < 0">
                <i class="el-icon-bottom" style="color: #67c23a;"></i>
                {{ formatAmount(displayUser.channel_users_total || 0) }}元
              </div>
              <div class="stat-hover">点击查看详情</div>
            </div>
          </el-col>
          <el-col :span="5">
            <div class="stat-item team-stat" @click="viewTeamRecords('city')">
              <div class="stat-value">{{ formatAmount(displayUser.city_users_total || 0) }}元</div>
              <div class="stat-label">市级推荐奖励</div>
              <div class="stat-hover">点击查看详情</div>
            </div>
          </el-col>
          <el-col :span="5">
            <div class="stat-item team-stat" @click="viewTeamRecords('all')">
              <div class="stat-value" style="color: #ff7600;">{{ formatAmount(displayUser.moneys || 0) }}元</div>
              <div class="stat-label">总利润</div>
              <div class="stat-hover">点击查看详情</div>
            </div>
          </el-col>
        </template>
      </el-row>
    </el-card>

    <!-- 内容区域 -->
    <div class="product-content">
      <div class="table-wrap">
        <el-table 
          size="small" 
          :data="tableData" 
          border 
          style="width: 100%" 
          v-loading="loading"
          @sort-change="handleSortChange"
        >
          <el-table-column prop="jxs_agent_log_id" label="记录ID" width="100" sortable="custom"></el-table-column>
          <el-table-column prop="pay_price" label="收入" width="120" align="right">
            <template slot-scope="scope">
              <span style="color: #ff7600; font-weight: bold;">
                +{{ formatAmount(scope.row.pay_price) }}元
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="price" label="利润" width="120" align="right">
            <template slot-scope="scope">
              <span style="color: #52c41a; font-weight: bold;">
                {{ formatAmount(scope.row.price) }}元
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="agent_user_id" label="代理用户ID" width="120"></el-table-column>
          <el-table-column prop="user_id" label="用户ID" width="120"></el-table-column>
          <el-table-column prop="user_role" label="角色" width="120">
            <template slot-scope="scope">
              <el-tag :type="getRoleType(scope.row.user_role)" size="small">
                {{ getRoleText(scope.row.user_role) }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="remark" label="备注" min-width="200">
            <template slot-scope="scope">
              <span v-if="scope.row.remark" class="remark-text">{{ scope.row.remark }}</span>
              <span v-else style="color: #999;">无备注</span>
            </template>
          </el-table-column>
          <el-table-column prop="create_time" label="创建时间" width="180" sortable="custom">
            <template slot-scope="scope">
              {{ formatTime(scope.row.create_time) }}
            </template>
          </el-table-column>
          <el-table-column prop="update_time" label="更新时间" width="180" sortable="custom">
            <template slot-scope="scope">
              {{ formatTime(scope.row.update_time) }}
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="120">
            <template slot-scope="scope">
              <el-button 
                @click="viewDetail(scope.row)" 
                type="text" 
                size="small"
              >查看详情</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 分页组件 -->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background 
          :current-page="curPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>

    <!-- 用户选择组件 -->
    <GetUser 
      :is_open="userDialogVisible" 
      @close="closeUserDialog"
      :multi="false"
    ></GetUser>

    <!-- 详情对话框 -->
    <el-dialog
      title="代理记录详情"
      :visible.sync="detailDialogVisible"
      width="50%"
      :before-close="handleDetailClose"
    >
      <agent-detail 
        v-if="detailDialogVisible" 
        :record-id="currentRecordId"
        :display-user="displayUser"
      ></agent-detail>
    </el-dialog>

    <!-- 团队成员记录对话框 -->
    <el-dialog
      :title="teamDialogTitle"
      :visible.sync="teamDialogVisible"
      width="80%"
      :before-close="handleTeamDialogClose"
    >
      <div class="team-records-dialog">
        <!-- 团队成员筛选 -->
        <div class="team-filter" style="margin-bottom: 20px;">
          <el-form size="small" inline>
            <el-form-item label="团队成员">
              <el-select v-model="selectedTeamMember" placeholder="选择团队成员" clearable>
                <el-option
                  v-for="member in teamMembers"
                  :key="member.user_id"
                  :label="`${member.nickName} (ID:${member.user_id})`"
                  :value="member.user_id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="loadTeamRecords">查询</el-button>
              <el-button @click="resetTeamFilter">重置</el-button>
            </el-form-item>
          </el-form>
        </div>

        <!-- 团队成员记录表格 -->
        <el-table 
          size="small" 
          :data="teamRecords" 
          border 
          style="width: 100%" 
          v-loading="teamLoading"
        >
          <el-table-column prop="jxs_agent_log_id" label="记录ID" width="100"></el-table-column>
          <el-table-column prop="pay_price" label="收入" width="120" align="right">
            <template slot-scope="scope">
              <span style="color: #ff7600; font-weight: bold;">
                +{{ formatAmount(scope.row.pay_price) }}元
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="price" label="利润" width="120" align="right">
            <template slot-scope="scope">
              <span style="color: #52c41a; font-weight: bold;">
                {{ formatAmount(scope.row.price) }}元
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="agent_user_id" label="代理用户ID" width="120"></el-table-column>
          <el-table-column prop="user_id" label="用户ID" width="120"></el-table-column>
          <el-table-column prop="agent_role" label="角色" width="120">
            <template slot-scope="scope">
              <el-tag :type="getRoleType(scope.row.agent_role)" size="small">
                {{ getRoleText(scope.row.agent_role) }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="remark" label="备注" min-width="200">
            <template slot-scope="scope">
              <span v-if="scope.row.remark" class="remark-text">{{ scope.row.remark }}</span>
              <span v-else style="color: #999;">无备注</span>
            </template>
          </el-table-column>
          <el-table-column prop="create_time" label="创建时间" width="180">
            <template slot-scope="scope">
              {{ formatTime(scope.row.create_time) }}
            </template>
          </el-table-column>
        </el-table>

        <!-- 团队成员记录分页 -->
        <div class="pagination" style="margin-top: 20px;">
          <el-pagination
            @size-change="handleTeamSizeChange"
            @current-change="handleTeamCurrentChange"
            background 
            :current-page="teamCurPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="teamPageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="teamTotalDataNumber"
          ></el-pagination>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import PromotionApi from '@/api/promotion.js';
import GetUser from '@/components/user/GetUsera.vue';

// 定义详情子组件（Vue 2 局部组件写法）
const AgentDetail = {
  name: 'AgentDetail',
  props: {
    recordId: {
      type: [Number, String],
      required: true,
      default: ''
    },
    displayUser: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      detailData: null
    }
  },
  methods: {
    // 格式化金额
    formatAmount(amount) {
      if (!amount) return '0.00';
      return parseFloat(amount).toFixed(2);
    },
    // 格式化时间戳
    formatTime(timestamp) {
      if (!timestamp) return '未知时间';
      // 兼容秒级和毫秒级时间戳
      const ts = timestamp.toString().length === 10 ? timestamp * 1000 : timestamp;
      const date = new Date(ts);
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');
      const hours = date.getHours().toString().padStart(2, '0');
      const minutes = date.getMinutes().toString().padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}`;
    },
    // 获取角色标签类型
    getRoleType(role) {
      const roleMap = {
        'province': 'success',
        'company_province': 'success',
        'city': 'primary',
        'company_city': 'primary',
        'channel': 'warning',
        'district_agent': 'warning',
        'common_agent': 'info'
      };
      return roleMap[role] || 'info';
    },
    // 获取角色文本
    getRoleText(role) {
      const roleMap = {
        'province': '省经销商',
        'company_province': '省级用户',
        'cross_border':'跨境云',
        'enterprise':'企业',
        'city': '市经销商',
        'company_city': '市级用户',
        'channel': '渠道用户',
        'district_agent': '区经销商',
        'common_agent': '普通代理'
      };
      return roleMap[role] || role;
    },
    // 加载详情数据
    loadDetail() {
      this.detailData = null;
      if (!this.recordId) return;

      // API 请求封装
      if (typeof PromotionApi.getAgentDetail === 'function') {
        PromotionApi.getAgentDetail({ id: this.recordId })
          .then(res => {
            this.detailData = res.data || {};
          })
          .catch(err => {
            console.error('加载详情失败:', err);
            this.$message.error('加载详情失败，请稍后重试');
            this.detailData = {};
          });
      } else {
        // 模拟数据
        this.detailData = {
          jxs_agent_log_id: this.recordId,
          pay_price: 0,
          price: 0,
          agent_user_id: 0,
          user_id: 0,
          role: '',
          app_id: '',
          is_delete: 0,
          remark: '',
          create_time: Date.now(),
          update_time: Date.now()
        };
      }
    }
  },
  watch: {
    recordId: {
      immediate: true,
      handler() {
        this.loadDetail();
      }
    }
  },
  template: `
    <div v-if="detailData">
      <el-descriptions :column="2" border>
        <el-descriptions-item label="记录ID">{{ detailData.jxs_agent_log_id }}</el-descriptions-item>
        <el-descriptions-item label="收入">
          <span style="color: #ff7600; font-weight: bold;">+{{ formatAmount(detailData.pay_price) }}元</span>
        </el-descriptions-item>
        <el-descriptions-item label="利润">
          <span style="color: #52c41a; font-weight: bold;">{{ formatAmount(detailData.price) }}元</span>
        </el-descriptions-item>
        <el-descriptions-item label="代理用户ID">{{ detailData.agent_user_id }}</el-descriptions-item>
        <el-descriptions-item label="用户ID">{{ detailData.user_id }}</el-descriptions-item>
        <el-descriptions-item label="角色">
          <el-tag :type="getRoleType(detailData.role)" size="small">
            {{ getRoleText(detailData.role) }}
          </el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="APP ID">{{ detailData.app_id || '无' }}</el-descriptions-item>
        <el-descriptions-item label="是否删除">
          <el-tag :type="detailData.is_delete ? 'danger' : 'success'" size="small">
            {{ detailData.is_delete ? '已删除' : '正常' }}
          </el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="备注" :span="2">
          <span v-if="detailData.remark" class="remark-text">{{ detailData.remark }}</span>
          <span v-else style="color: #999;">无备注</span>
        </el-descriptions-item>
        <el-descriptions-item label="创建时间" :span="2">{{ formatTime(detailData.create_time) }}</el-descriptions-item>
        <el-descriptions-item label="更新时间" :span="2">{{ formatTime(detailData.update_time) }}</el-descriptions-item>
      </el-descriptions>
    </div>
    <div v-else>
      <el-skeleton :rows="5" animated />
    </div>
  `
};

export default {
  name: 'AgentStatsPage', // Vue 2 推荐指定组件名
  components: {
    GetUser,
    AgentDetail // 注册局部子组件
  },
  data() {
    return {
      // 基础加载状态
      loading: false,
      // 表格数据
      tableData: [],
      pageSize: 20,
      totalDataNumber: 0,
      curPage: 1,
      // 搜索表单
      searchForm: {
        user_id: '',
        dateRange: []
      },
      // 用户选择相关
      selectedUser: null,
      selectedUserName: '',
      userDialogVisible: false,
      // 统计数据
      totalIncome: 0,
      totalProfit: 0,
      totalCount: 0,
      todayIncome: 0,
      todayProfit: 0,
      todayCount: 0,
      // 团队统计数据
      teamTotalIncome: 0,
      teamTotalProfit: 0,
      teamTotalCount: 0,
      teamTodayIncome: 0,
      teamTodayProfit: 0,
      teamTodayCount: 0,
      teamIncomeTrend: 0,
      teamProfitTrend: 0,
      // 快捷筛选
      activeQuickFilter: 4,
      quickFilters: [
        { name: '今天', days: 0 },
        { name: '近7天', days: 7 },
        { name: '近30天', days: 30 },
        { name: '本月', days: -1 },
        { name: '全部', days: -2 }
      ],
      // 详情弹窗
      detailDialogVisible: false,
      currentRecordId: null,
      // 团队记录弹窗
      teamDialogVisible: false,
      teamDialogTitle: '',
      teamRecords: [],
      teamMembers: [],
      selectedTeamMember: '',
      teamLoading: false,
      teamCurPage: 1,
      teamPageSize: 20,
      teamTotalDataNumber: 0,
      currentTeamType: '',
      // 用户核心数据
      user: {
        yfk: 0,
        jsj: 0,
        num: 0,
        saletask: 0,
        company_num: 0,
        role: '',
        direct_completed: 0,
        city_completed: 0,
        channel_completed: 0,
        total_completed: 0,
        current_user_total: 0,
        channel_users_total: 0,
        city_users_total: 0,
        moneys: 0
      },
      currentCityUser: null
    };
  },
  computed: {
    // 计算显示的用户数据
    displayUser() {
      return this.currentCityUser ? this.currentCityUser : this.user;
    }
  },
  created() {
    this.getTableList();
    this.loadStats();
  },
  methods: {
    // 打开用户选择弹窗
    openUserDialog() {
      this.userDialogVisible = true;
    },
    // 关闭用户选择弹窗
    closeUserDialog(e) {
      this.userDialogVisible = false;
      if (e && e.type === 'success' && e.params) {
        const user = e.params;
        this.selectedUser = user;
        this.selectedUserName = `${user.nickName || '未知用户'} (ID:${user.user_id})`;
        this.searchForm.user_id = user.user_id;
        
        // Vue 2 响应式更新对象
        this.user = {
          ...this.user,
          ...user,
          saletask: user.saletask || 0,
          company_num: user.company_num || 0,
          jsj: user.jsj || 0,
          direct_completed: user.direct_completed || 0,
          city_completed: user.city_completed || 0,
          channel_completed: user.channel_completed || 0,
          total_completed: user.total_completed || 0,
          current_user_total: user.current_user_total || 0,
          channel_users_total: user.channel_users_total || 0,
          city_users_total: user.city_users_total || 0,
          moneys: user.moneys || 0
        };
        
        // 自动加载数据
        this.loadStats();
        this.getTableList();
      }
    },
    // 清除用户选择
    clearUserSelection() {
      this.selectedUser = null;
      this.selectedUserName = '';
      this.searchForm.user_id = '';
      this.tableData = [];
      this.resetStats();
      
      // 重置用户数据
      this.user = {
        yfk: 0,
        jsj: 0,
        num: 0,
        saletask: 0,
        company_num: 0,
        role: '',
        direct_completed: 0,
        city_completed: 0,
        channel_completed: 0,
        total_completed: 0,
        current_user_total: 0,
        channel_users_total: 0,
        city_users_total: 0,
        moneys: 0
      };
      this.currentCityUser = null;
    },
    // 重置统计数据
    resetStats() {
      this.totalIncome = 0;
      this.totalProfit = 0;
      this.totalCount = 0;
      this.todayIncome = 0;
      this.todayProfit = 0;
      this.todayCount = 0;
      this.teamTotalIncome = 0;
      this.teamTotalProfit = 0;
      this.teamTotalCount = 0;
      this.teamTodayIncome = 0;
      this.teamTodayProfit = 0;
      this.teamTodayCount = 0;
      this.teamIncomeTrend = 0;
      this.teamProfitTrend = 0;
    },
    // 加载统计数据
    loadStats() {
      if (!this.selectedUser) {
        var user_id = 0;
      }else{
        var user_id = this.selectedUser.user_id
      }
      
      const params = {
        user_id: user_id
      };

      // 处理日期范围
      if (this.searchForm.dateRange && this.searchForm.dateRange.length === 2) {
        params.start_date = this.searchForm.dateRange[0];
        params.end_date = this.searchForm.dateRange[1];
      }

      if (typeof PromotionApi.getAgentStats === 'function') {
        PromotionApi.getAgentStats(params)
          .then(res => {
            if (res && res.code === 1) {
              const data = res.data || {};
              // 更新个人数据
              this.totalIncome = data.total_income || 0;
              this.totalProfit = data.total_profit || 0;
              this.totalCount = data.total_count || 0;
              this.todayIncome = data.today_income || 0;
              this.todayProfit = data.today_profit || 0;
              this.todayCount = data.today_count || 0;
              
              // 更新团队数据（仅省级用户）
              if(this.selectedUser){
                if (['province', 'company_province'].includes(this.selectedUser.role)) {
                  this.teamTotalIncome = data.team_total_income || 0;
                  this.teamTotalProfit = data.team_total_profit || 0;
                  this.teamTotalCount = data.team_total_count || 0;
                  this.teamTodayIncome = data.team_today_income || 0;
                  this.teamTodayProfit = data.team_today_profit || 0;
                  this.teamTodayCount = data.team_today_count || 0;
                  this.teamIncomeTrend = data.team_income_trend || 0;
                  this.teamProfitTrend = data.team_profit_trend || 0;
                }
              }
            }
          })
          .catch(err => {
            console.error('加载统计数据失败:', err);
            this.$message.error('加载统计数据失败，请稍后重试');
            this.resetStats();
          });
      } else {
        this.resetStats();
      }
    },
    // 获取表格列表数据
    getTableList() {
      this.loading = true;
      const params = {
        ...this.searchForm,
        page: this.curPage,
        list_rows: this.pageSize
      };

      // 处理日期范围参数
      if (params.dateRange && params.dateRange.length === 2) {
        params.start_date = params.dateRange[0];
        params.end_date = params.dateRange[1];
        delete params.dateRange;
      }

      if (typeof PromotionApi.getAgentList === 'function') {
        PromotionApi.getAgentList(params)
          .then(res => {
            this.loading = false;
            if (res && res.code === 1) {
              this.tableData = (res && res.data && res.data.list && res.data.list.data) ? res.data.list.data : [];
              this.totalDataNumber = (res && res.data && res.data.list && res.data.list.total) ? res.data.list.total : 0;
            } else {
              this.tableData = [];
              this.totalDataNumber = 0;
            }
          })
          .catch(() => {
            this.loading = false;
            this.tableData = [];
            this.totalDataNumber = 0;
            this.$message.error('加载列表数据失败，请稍后重试');
          });
      } else {
        this.loading = false;
        this.tableData = [];
        this.totalDataNumber = 0;
      }
    },
    // 分页 - 页码切换
    handleCurrentChange(val) {
      this.curPage = val;
      this.getTableList();
    },
    // 分页 - 每页条数切换
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },
    // 表格排序
    handleSortChange({ column, prop, order }) {
      console.log('排序:', prop, order);
      this.getTableList();
    },
    // 搜索提交
    onSubmit() {
      this.curPage = 1;
      this.loadStats();
      this.getTableList();
    },
    // 重置搜索
    resetSearch() {
      this.searchForm = {
        user_id: this.searchForm.user_id, // 保留用户选择
        dateRange: []
      };
      this.activeQuickFilter = 4;
      this.loadStats();
      this.getTableList();
    },
    // 快捷筛选切换
    changeQuickFilter(index) {
      this.activeQuickFilter = index;
      const filter = this.quickFilters[index];
      
      if (filter.days === -2) {
        this.searchForm.dateRange = []; // 全部
      } else if (filter.days === -1) {
        // 本月
        const now = new Date();
        this.searchForm.dateRange = [
          this.formatDate(new Date(now.getFullYear(), now.getMonth(), 1)),
          this.formatDate(now)
        ];
      } else {
        // 具体天数
        const endDate = new Date();
        const startDate = new Date();
        startDate.setDate(startDate.getDate() - filter.days);
        
        this.searchForm.dateRange = [
          this.formatDate(startDate),
          this.formatDate(endDate)
        ];
      }
      
      this.onSubmit();
    },
    // 查看详情
    viewDetail(row) {
      if (row && row.jxs_agent_log_id) {
        this.currentRecordId = row.jxs_agent_log_id;
        this.detailDialogVisible = true;
      }
    },
    // 关闭详情弹窗
    handleDetailClose() {
      this.detailDialogVisible = false;
      this.currentRecordId = null;
    },
    // 查看团队记录
    viewTeamRecords(type) {
      if (!this.selectedUser || !['province', 'company_province'].includes(this.selectedUser.role)) {
        this.$message.warning('仅省级用户可查看团队记录');
        return;
      }

      this.currentTeamType = type;
      this.teamDialogTitle = this.getTeamDialogTitle(type);
      this.teamDialogVisible = true;
      
      this.loadTeamMembers();
      this.loadTeamRecords();
    },
    // 获取团队弹窗标题
    getTeamDialogTitle(type) {
      const titleMap = {
        'income': '团队收入记录',
        'profit': '团队利润记录',
        'count': '团队记录数详情',
        'today_income': '团队今日收入记录',
        'today_profit': '团队今日利润记录',
        'today_count': '团队今日记录详情'
      };
      return titleMap[type] || '团队成员记录';
    },
    // 加载团队成员
    loadTeamMembers() {
      if (!this.selectedUser) return;

      if (typeof PromotionApi.getTeamMembers === 'function') {
        PromotionApi.getTeamMembers({ province_user_id: this.selectedUser.user_id })
          .then(res => {
            if (res && res.code === 1) {
              this.teamMembers = (res && res.data && res.data.members) ? res.data.members : [];
            }
          })
          .catch(err => {
            console.error('加载团队成员失败:', err);
            this.$message.error('加载团队成员失败，请稍后重试');
            this.teamMembers = [];
          });
      } else {
        this.teamMembers = [];
      }
    },
    // 加载团队记录
    loadTeamRecords() {
      if (!this.selectedUser) return;

      this.teamLoading = true;
      const params = {
        type:this.currentTeamType,
        province_user_id: this.selectedUser.user_id,
        page: this.teamCurPage,
        list_rows: this.teamPageSize
      };

      // 成员筛选
      if (this.selectedTeamMember) {
        params.user_id = this.selectedTeamMember;
      }

      // 日期筛选
      if (this.currentTeamType.includes('today')) {
        params.start_date = this.formatDate(new Date());
        params.end_date = this.formatDate(new Date());
      } else if (this.searchForm.dateRange && this.searchForm.dateRange.length === 2) {
        params.start_date = this.searchForm.dateRange[0];
        params.end_date = this.searchForm.dateRange[1];
      }

      if (typeof PromotionApi.getTeamRecords === 'function') {
        PromotionApi.getTeamRecords(params)
          .then(res => {
            this.teamLoading = false;
            if (res && res.code === 1) {
              this.teamRecords = (res && res.data && res.data.list && res.data.list.data) ? res.data.list.data : [];
              this.teamTotalDataNumber = (res && res.data && res.data.list && res.data.list.total) ? res.data.list.total : 0;
            } else {
              this.teamRecords = [];
              this.teamTotalDataNumber = 0;
            }
          })
          .catch(() => {
            this.teamLoading = false;
            this.teamRecords = [];
            this.teamTotalDataNumber = 0;
            this.$message.error('加载团队记录失败，请稍后重试');
          });
      } else {
        this.teamLoading = false;
        this.teamRecords = [];
        this.teamTotalDataNumber = 0;
      }
    },
    // 重置团队筛选
    resetTeamFilter() {
      this.selectedTeamMember = '';
      this.teamCurPage = 1;
      this.loadTeamRecords();
    },
    // 团队分页 - 页码切换
    handleTeamCurrentChange(val) {
      this.teamCurPage = val;
      this.loadTeamRecords();
    },
    // 团队分页 - 每页条数切换
    handleTeamSizeChange(val) {
      this.teamCurPage = 1;
      this.teamPageSize = val;
      this.loadTeamRecords();
    },
    // 关闭团队弹窗
    handleTeamDialogClose() {
      this.teamDialogVisible = false;
      this.selectedTeamMember = '';
      this.teamCurPage = 1;
      this.teamRecords = [];
    },
    // 格式化金额
    formatAmount(amount) {
      if (!amount) return '0.00';
      return parseFloat(amount).toFixed(2);
    },
    // 格式化日期
    formatDate(date) {
      if (!date) return '';
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    // 格式化时间戳
    formatTime(timestamp) {
      if (!timestamp) return '未知时间';
      const ts = timestamp.toString().length === 10 ? timestamp * 1000 : timestamp;
      const date = new Date(ts);
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');
      const hours = date.getHours().toString().padStart(2, '0');
      const minutes = date.getMinutes().toString().padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}`;
    },
    // 获取角色标签类型
    getRoleType(role) {
      const roleMap = {
        'province': 'success',
        'company_province': 'success',
        'city': 'primary',
        'company_city': 'primary',
        'channel': 'warning',
        'district_agent': 'warning',
        'common_agent': 'info'
      };
      return roleMap[role] || 'info';
    },
    // 获取角色文本
    getRoleText(role) {
      const roleMap = {
        'province': '省经销商',
        'company_province': '省级用户',
        'cross_border':'跨境云',
        'enterprise':'企业',
        'city': '市经销商',
        'company_city': '市级用户',
        'channel': '渠道用户',
        'district_agent': '区经销商',
        'common_agent': '普通代理'
      };
      return roleMap[role] || role;
    }
  }
};
</script>

<style scoped>
.agent-stats-page {
  padding: 20px;
}

.user-info-card {
  margin-bottom: 20px;
}

.user-info-item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.user-info-item label {
  font-weight: bold;
  color: #606266;
  margin-right: 8px;
}

.user-avatar {
  border-radius: 50%;
}

.stats-card {
  margin-bottom: 20px;
}

.stat-item {
  text-align: center;
  padding: 20px 0;
  position: relative;
  cursor: default;
}

.team-stat {
  background: linear-gradient(135deg, #f8f9ff 0%, #f0f2ff 100%);
  border-radius: 8px;
  border-left: 4px solid #409eff;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.team-stat:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(64, 158, 255, 0.2);
  background: linear-gradient(135deg, #e6f7ff 0%, #d6e4ff 100%);
}

.stat-value {
  font-size: 24px;
  font-weight: bold;
  color: #303133;
  margin-bottom: 8px;
  transition: all 0.3s ease;
}

.team-stat:hover .stat-value {
  color: #409eff;
  transform: scale(1.05);
}

.stat-label {
  font-size: 14px;
  color: #909399;
  transition: all 0.3s ease;
}

.team-stat:hover .stat-label {
  color: #409eff;
  font-weight: bold;
}

.stat-trend {
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 12px;
  font-weight: bold;
}

.stat-hover {
  position: absolute;
  bottom: -20px;
  left: 0;
  right: 0;
  background: rgba(64, 158, 255, 0.9);
  color: white;
  font-size: 12px;
  padding: 2px 0;
  opacity: 0;
  transition: all 0.3s ease;
}

.team-stat:hover .stat-hover {
  bottom: 0;
  opacity: 1;
}

.remark-text {
  background-color: #f8f9fa;
  padding: 4px 8px;
  border-radius: 4px;
  display: inline-block;
}

.common-seach-wrap {
  margin-bottom: 20px;
}

.product-content {
  background: #fff;
  padding: 20px;
  border-radius: 4px;
}

.pagination {
  margin-top: 20px;
  text-align: right;
}

.el-radio-group {
  margin-left: 10px;
}

.team-records-dialog {
  max-height: 60vh;
  overflow-y: auto;
}

.team-filter {
  background: #f8f9fa;
  padding: 15px;
  border-radius: 4px;
}

/* 响应式适配 */
@media (max-width: 1200px) {
  .stats-card .el-col {
    margin-bottom: 10px;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/statistics/report/jxs.vue